import { VStack, Text, Checkbox, Radio, Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "lucide-react";
import { useLocation, useParams } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";

const FileDropdown: React.FC<FileDropdownProps> = ({
  files,
  selectedFiles,
  onChange,
  isMultiFiles = true,
  isLegalChatbot = false,
  openUpward = false,
}) => {
  const { t } = useTranslation("common");
  const { pathname } = useLocation();
  const isMultiDoc = pathname?.startsWith(ROUTE_NAMES.CHECKLIST);

  const toggleFile = (file: UploadedDocument) => {
    const isSelected = selectedFiles?.some((f) => f?.id === file?.id);
    const updatedFiles = isSelected
      ? selectedFiles?.filter((f) => f?.id !== file?.id)
      : [...selectedFiles, file];
    onChange(updatedFiles);
  };

  const selectFile = (file: UploadedDocument) => {
    onChange([file]);
  };

  const renderFileCheckboxes = () =>
    files?.map((file) => {
      const isPdf =
        file?.fileName_key?.toLowerCase().endsWith(".pdf") ||
        file?.fileName?.toLowerCase().endsWith(".pdf");
      const shouldRender = isLegalChatbot || isMultiDoc ? true : isPdf;

      return (
        shouldRender && (
          <Checkbox
            key={file?.id}
            isChecked={selectedFiles?.some((f) => f?.id === file?.id)}
            onChange={() => toggleFile(file)}
            colorScheme="blue"
          >
            {file?.fileName_key || file?.fileName}
          </Checkbox>
        )
      );
    });

  const renderFileRadios = () => {
    const selectedId = selectedFiles?.[0]?.id || "";
    return files?.map((file) => {
      const isPdf =
        file?.fileName_key?.toLowerCase().endsWith(".pdf") ||
        file?.fileName?.toLowerCase().endsWith(".pdf");
      const shouldRender = isLegalChatbot ? true : isPdf;

      return (
        shouldRender && (
          <Radio
            key={file?.id}
            value={file?.id.toString()}
            isChecked={selectedId === file?.id}
            onChange={() => selectFile(file)}
            colorScheme="blue"
          >
            {file?.fileName_key || file?.fileName}
          </Radio>
        )
      );
    });
  };

  return (
    <Box
      maxH="450px"
      overflowY="auto"
      borderRadius="12px"
      border="1px solid #D6DFEB"
      boxShadow="lg"
      px={5}
      py={5}
      bg="white"
      zIndex={10}
      minW="400px"
      maxW="250px"
      position="absolute"
      bottom={openUpward ? "100%" : "auto"}
      top={openUpward ? "auto" : "100%"}
      mb={openUpward ? "8px" : "0"}
      mt={openUpward ? "0" : "8px"}
    >
      {files?.length === 0 ? (
        <Text fontSize="sm" px={2} py={1} color="gray.500">
          {t("translate.noFiles")}
        </Text>
      ) : (
        <VStack align="start" spacing={2}>
          {isMultiFiles ? renderFileCheckboxes() : renderFileRadios()}
        </VStack>
      )}
    </Box>
  );
};

export default FileDropdown;
